"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlaygroundProperty = exports.playgroundPropertyDefinition = void 0;
exports.playgroundPropertyDefinition = {
    view: {
        label: 'Playground',
        style: 'tag',
        hint: 'No playground project to assign this asset to? Add a playground tag on the most granular level.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: ['playground'],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'playground',
};
const isPlaygroundProperty = (prop) => {
    return prop.name === exports.playgroundPropertyDefinition.name;
};
exports.isPlaygroundProperty = isPlaygroundProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGxheWdyb3VuZC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BsYXlncm91bmQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsWUFBWTtRQUNuQixLQUFLLEVBQUUsS0FBSztRQUNaLElBQUksRUFBRSxpR0FBaUc7S0FDeEc7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxJQUFJO1NBQ2Y7UUFDRDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLFlBQVksQ0FBQztTQUN6QjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxZQUFZO0NBQ2EsQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQyJ9